
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/forms/form6";
const form6State = namespace("Form6");

import Form6ProcessHeader from "@/components/process/Form6/components/Form6ProcessHeader.vue";
import Spinner from "@/components/utils/Spinner.vue";
import { form6DataInfoType, form6StatusInfoType } from '@/types/Information/Form6';
import { packageInfoType } from '@/types/Information';

import { GetForm6PdfType } from "./components/Form6PdfType"

@Component({
    components:{
        Form6ProcessHeader,
        Spinner
    }
})
export default class SubmitForm6 extends Vue {

    @form6State.State
    public currentNoticeOfSettlementOrAbandonmentId: string;

    @form6State.State
    public form6Info: form6DataInfoType;

    stepsCompleted = {} as form6StatusInfoType;  
    mountedData = false; 
    packageInfo = {} as packageInfoType;
    submitting = false;
    errorMsg=""

    mounted() {
        this.mountedData = false;    
        this.submitting = false;    
        this.errorMsg = ""
        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;         
    }  

    public submit() {

        this.submitting = true;
        this.errorMsg =""

        const url = "/form6/efiling/"+this.currentNoticeOfSettlementOrAbandonmentId+"/submit/";

        const header = {
            responseType: "json",
            headers: {
                "Content-Type": "application/json",
            }
        }

        const body = {
            document_type: GetForm6PdfType(this.form6Info) //"ABA"
        }

        this.$http.post(url, body, header)
        .then(res => {                            
            // this.submitting = false;
            if(res.data?.message=="success" && res.data?.redirectUrl){
                const eFilingUrl = res.data?.redirectUrl
                location.replace(eFilingUrl);
            }else
                this.submitting = false;
        }, err => {
            console.log(err.response?.data?.message);
            const generalError = " Error in submission. Please refresh the page and try again."
            if(err.response?.data?.message)
                this.errorMsg = err.response.data.message
            else if(err.response?.data?.detail)
                this.errorMsg = err.response.data.detail+generalError
            else
                this.errorMsg = generalError
            this.submitting = false;
        });        
    }

    public cancel() {
        this.$router.push({name: "dashboard" }) 
    }
}
